import { useAuth } from '@omnipresentgroup/auth';
import { AUTH0_ROLES, AUTH0_USERID } from '@omnipresentgroup/constants';

export const useManagerUser = () => {
  const { user: authUser } = useAuth();

  return {
    userId: authUser?.[AUTH0_USERID] || '',
    companyId:
      authUser?.[AUTH0_ROLES].find(
        (role: { type: string }) => role.type === 'manager',
      )?.tenantId || '',
    authUser,
  };
};
